import { render, staticRenderFns } from "./driverWithdrawalRule.vue?vue&type=template&id=230f8357"
import script from "./driverWithdrawalRule.vue?vue&type=script&lang=js"
export * from "./driverWithdrawalRule.vue?vue&type=script&lang=js"
import style0 from "./driverWithdrawalRule.vue?vue&type=style&index=0&id=230f8357&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports